import AppComponent from '../../mixins/app-component'

export default
{
    name: 'app-home-slide',

    mixins: [
        AppComponent
    ],

    props: {
        activeIndex: { type: Number, default: 0 },
        activeLevel: { type: Number, default: 0 },
        index: { type: Number, default: 0 },
        nbLevels: { type: Number, default: 0 }
    },

    data() {
        return {
            isActive: false,
            isLeft: false,
            isRight: false
        }
    },

    watch: {
        activeIndex: 'onActiveIndexChange'
    },

    mounted() {
        this.onActiveIndexChange()
    },

    methods: {
        onActiveIndexChange() {
            if (this.activeIndex === this.index) {
                this.isActive = true
                this.isLeft = false
                this.isRight = false
            } else {
                this.isActive = false
                this.isLeft = this.index < this.activeIndex
                this.isRight = this.index > this.activeIndex
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-slide/script.js